export const camelizeKey = (
  key: string,
  camelizeFunction: (key: string, ...rest: any[]) => string,
) => {
  const camelizedKey = camelizeFunction(key);

  return /^__/.test(key) ? `__${camelizedKey}` : camelizedKey;
};
